import Icon from '../Icon/Icon';

// TODO: Replace with the correct icon once provided by design.
const BadgeActionArrowIcon = ({className}: {className?: string}) => (
    <Icon width='40' height='40' fill='none' className={className}>
        <circle cx='20' cy='20' r='20' fill='#383E42' />
        <path
            d='M23.0938 14.9648L28.3245 20.1956L23.0938 25.4264'
            stroke='#3AC9F3'
            strokeWidth='1.5'
            strokeLinecap='round'
        />
        <path d='M27 20.1956H12' stroke='#3AC9F3' strokeWidth='1.5' strokeLinecap='square' />
    </Icon>
);

export default BadgeActionArrowIcon;
